<template>
  <div class="registration-content">
    <b-alert variant="danger" :show="!!$fetchState.error">
      Ошибка при загрузке данных
    </b-alert>
    <template v-if="!$fetchState.error">
      <h2 class="text-center">
        Регистрация
      </h2>
      <div class="registration-form">
        <b-overlay :show="isLoading" :opacity="0">
          <validation-observer v-slot="{handleSubmit}">
            <b-form @submit.prevent="handleSubmit(saveToStore)">
              <b-form-group
                label-cols-sm="5"
                label-cols-lg="5"
                label="ЭЦП"
                label-for="eds"
                label-size="sm"
                :state="!ncalayerConnectionError"
                :invalid-feedback="WsErrorFeedback"
              >
                <ncalayer-button @click="getDataFromEDS">
                  <template slot="connected-state">
                    Выбрать ЭЦП
                  </template>
                </ncalayer-button>
              </b-form-group>
              <b-form-group
                label-cols-sm="5"
                label-cols-lg="5"
                label="Наименование ЦТО"
                label-for="ctoTitle"
                label-size="sm"
              >
                <b-form-input
                  id="ctoTitle"
                  v-model="organizationName"
                  type="text"
                  size="sm"
                  disabled
                />
              </b-form-group>
              <validation-provider v-slot="{validated, errors, valid}" rules="required">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Город"
                  label-for="cityRcoId"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    id="cityRcoId"
                    v-model="form.cityRcoId"
                    :disabled="disabled"
                    size="sm"
                    :state="validated ? valid : null"
                    name="cityRcoId"
                    data-vv-as="Город"
                    :options="cities.map(model => {return {value: model.rcoId, text: model.title}})"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{ errors, validated, valid }" rules="required">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Адрес"
                  label-for="address"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-input
                    id="address"
                    v-model.trim="form.address"
                    :disabled="disabled"
                    type="text"
                    :state="validated ? valid: null"
                    name="address"
                    data-vv-as="Адрес"
                    size="sm"
                    placeholder="Введите адрес"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{valid, errors, validated}" :rules="{required: true}">
                <b-form-group
                  label="Загрузите устав компании"
                  label-for="file-small"
                  label-cols-sm="5"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-file
                    id="file-small"
                    v-model="form.charter"
                    :disabled="disabled"
                    size="sm"
                    :state="validated ? valid : null"
                    name="companyCharter"
                    data-vv-as="Устав компании"
                    placeholder="Файл не выбран"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{errors, validated, valid}" rules="required|email">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Электронная почта"
                  label-for="Email"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.email"
                    :disabled="disabled"
                    type="email"
                    :state="validated ? valid : null"
                    name="email"
                    size="sm"
                    placeholder="Введите адрес электронной почты"
                  />
                </b-form-group>
              </validation-provider>
              <b-form-group
                label-cols-sm="5"
                label-cols-lg="5"
                label="Контактное лицо"
                label-for="input-1"
                label-size="sm"
              >
                <b-form-input
                  id="input-1"
                  v-model="contactPerson"
                  type="text"
                  size="sm"
                  disabled
                />
              </b-form-group>
              <validation-provider v-slot="{errors, valid, validated}" rules="required">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Телефон для работы с клиентами"
                  label-for="mainPhone"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-input
                    id="mainPhone"
                    v-model="form.firstPhone"
                    :disabled="disabled"
                    name="mainPhone"
                    :state="validated ? valid : null"
                    type="text"
                    size="sm"
                    placeholder="Введите номер телефона"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{errors, valid, validated}" rules="required">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Телефон для связи с Казахтелекомом"
                  label-for="secondPhone"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-input
                    id="secondPhone"
                    v-model="form.secondPhone"
                    :disabled="disabled"
                    name="secondPhone"
                    :state="validated ? valid : null"
                    type="text"
                    size="sm"
                    placeholder="Введите номер телефона"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{errors, valid, validated}" rules="required">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Рабочее время"
                  label-for="workingHours"
                  label-size="sm"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-input
                    id="secondPhone"
                    v-model="form.workingHours"
                    :disabled="disabled"
                    name="workingHours"
                    :state="validated ? valid : null"
                    type="text"
                    size="sm"
                    placeholder="Введите рабочее время"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{errors, valid, validated}" ref="cashRegisterModels" rules="required|min:1">
                <b-form-group
                  label-cols-sm="5"
                  label-cols-lg="5"
                  label="Модели ККМ"
                  label-for="input-1"
                  label-size="sm"
                  :state="validated ? valid : null"
                  :invalid-feedback="errors[0]"
                >
                  <multiselect
                    v-model="form.cashRegisterModels"
                    class="invalid"
                    :options="cashRegisterModels"
                    :multiple="true"
                    label="title"
                    track-by="id"
                    :close-on-select="false"
                    :clear-on-select="false"
                    @close="$refs.cashRegisterModels.validate()"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span v-if="values.length &amp;&amp; !isOpen" class="multiselect__single">{{ values.length }} выбрано</span>
                    </template>
                  </multiselect>
                </b-form-group>
              </validation-provider>
              <div class="text-center">
                <p>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="small"
                    :disabled="!canSubmit"
                  >
                    Продолжить
                  </b-button>
                </p>
                <p>
                  <nuxt-link to="/login" class="footer-link small">
                    ← Назад
                  </nuxt-link>
                </p>
              </div>
            </b-form>
          </validation-observer>
        </b-overlay>
      </div>
    </template>
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify'
import NcalayerButton from '~/components/NcalayerButton'

export default {
  name: 'FirstStep',
  components: { NcalayerButton },
  async fetch () {
    const [cities, cashRegisterModels] = await Promise.all([
      this.$axios.$get('/api/cities'),
      this.$axios.$get('/api/cashRegistersModels')
    ])
    this.cities = cities
    this.cashRegisterModels = cashRegisterModels
  },
  data () {
    return {
      isLoading: false,
      disabled: false,
      form: {
        cityRcoId: null,
        address: '',
        email: '',
        firstPhone: '',
        secondPhone: '',
        cashRegisterModels: [],
        charter: null,
        workingHours: null
      },
      cities: [],
      cashRegisterModels: []
    }
  },
  computed: {
    organizationName: get('signup/certificateInfo@organization'),
    contactPerson: get('signup/contactPerson'),
    WsError () {
      return this.$store.state.socket.isConnected
    },
    WsErrorFeedback () {
      if (!this.ncalayerConnected) {
        return 'NCAlayer не включен, включите его чтобы продолжить'
      }
      return null
    },
    canSubmit () {
      return this.organizationName
    },
    ncalayerConnected: get('ncalayer/isConnected'),
    ncalayerConnectionError: get('ncalayer/connectionError')
  },
  methods: {
    ncalayerGetKeyInfo: call('ncalayer/getKeyInfo'),
    checkCertificate: call('signup/checkCertificate'),
    create: call('signup/create'),
    async getDataFromEDS () {
      const { pem } = await this.ncalayerGetKeyInfo()
      const certificate = pem
        .replace('-----BEGIN CERTIFICATE-----', '')
        .replace('-----END CERTIFICATE-----', '')
        .replace(/\n/g, '')
      try {
        this.isLoading = true
        await this.checkCertificate(certificate)
      } finally {
        this.isLoading = false
      }
    },
    async saveToStore () {
      await this.create(this.form)
    }
  }
}
</script>

<style lang="scss">
.registration {
  &-content {
    background-color: #fff;
    min-height: 100vh;
    padding: 100px 140px 54px;
    border: 1px solid #cad0df;
    border-radius: 3px;
    max-width: 860px;
    margin: 0 auto;

    h2 {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
    }

    .col-form-label-sm {
      font-size: 13px;
      line-height: 20px;
      color: #8392A5;
    }
  }

  &-form {
    margin-top: 50px;
  }
}

.footer-link {
  color: #8392A5;
}

button.btn {
  margin-top: 64px;
  min-width: 260px;
}

.multiselect {
  min-height: 37px;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 13px;
  &__tags {
    min-height: 37px;
    max-height: 37px;
    border: 1px solid #CAD0DF;
    &-wrap {
      display: none;
    }
  }
  &__placeholder {
    display: none;
  }
  &__input {
    font-size: 0;
  }
  &__select {
    width: 34px;
    height: 37px;
    right: 0;
    top: 0;
    &:before{
      border-color: #333 transparent transparent;
      border-style: solid;
      border-width: 4px 4px 0;
      margin: 0;
    }
  }
  &__single {
    font-size: 13px;
  }
  &__content-wrapper {
    border-color: #CAD0DF;
    border-top: 1px solid #CAD0DF !important;
  }
  &__option {
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgcng9IjIuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzk3QTNCOSIvPgo8L3N2Zz4K") right 4px center no-repeat;
    background-size: 16px;
    white-space: normal;
    color: #001737;
    line-height: 1.25;
    min-height: 0;
    padding: 6px 26px 6px 8px;
    &.multiselect__option--highlight {
       background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgcng9IjIuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzk3QTNCOSIvPgo8L3N2Zz4K") right 4px center no-repeat;
       color: #001737;
    }
    &--selected {
      background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMyIgZmlsbD0iIzAxNjhGQSIvPgo8cGF0aCBkPSJNMTEgNkw2Ljg3NSAxMEw1IDguMTgxODIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=") right 4px center no-repeat;
      color: #001737;
      font-weight: 400;
      &.multiselect__option--highlight {
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMyIgZmlsbD0iIzAxNjhGQSIvPgo8cGF0aCBkPSJNMTEgNkw2Ljg3NSAxMEw1IDguMTgxODIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=") right 4px center no-repeat;
        color: #001737;
      }
    }
    &--highlight {
      background: inherit;
      color: #001737;
    }
    &:after{
      display: none;
    }
  }
}
</style>
